import api from "@/api/api-v2-config";

export async function getComplaintsListAxios() {
    return await api.get("complaints?pageNumber=1&pageSize=10000");
}

export async function deleteComplaintsAxios(id) {
    return await api.delete("complaints/" + id);
}

export async function postComplaintsAxios(payload) {
    return await api.post("complaints", payload);
}

export async function putComplaintsAxios(id, payload) {
    return await api.put("complaints/" + id, payload);
}

export async function getComplaintsByIdAxios(id) {
    return await api.get("complaints/" + id);
}

export async function updateComplaintStatus(payload){
    return await api.put("complaints/" + payload.id + "/status", payload);
}

export async function postFeebackAxios(payload) {
    return await api.post("complaints/feedback", payload);
}


export async function getComplaintFeedbackById(id) {
    return await api.get("complaints/" + id + "/feedback")
}


export async function deleteComplaintFeedbackAxios(id){
    return await api.delete("complaints/feedback/" + id)
}